// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"566":"8f4cfab1efdfabbf","883":"e65aa253dee1db04"}[chunkId] + ".js";
};